import React from 'react'
import { Button, CopyIconWrapper, CopyAltIconWrapper } from './styles'
import { IconComponent } from '~/assets/icons/component'

interface ICopyButtonProps {
  wasCopied: boolean
  disabled?: boolean
  onClick: React.MouseEventHandler
}

export const CopyButton = (props: ICopyButtonProps): JSX.Element => {
  const { wasCopied, onClick, disabled } = props
  return (
    <Button onClick={onClick} disabled={disabled}>
      {!wasCopied ? <CopyIcon /> : <CopyAltIcon />}
    </Button>
  )
}

const CopyIcon = (): JSX.Element => {
  return (
    <CopyIconWrapper data-testid="copy-icon-button">
      <IconComponent name="copy" />
    </CopyIconWrapper>
  )
}

const CopyAltIcon = (): JSX.Element => {
  return (
    <CopyAltIconWrapper data-testid="copy-alt-icon-button">
      <IconComponent name="copyAlt" />
    </CopyAltIconWrapper>
  )
}
